import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Transfers = ({ fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.tab.default;

  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.625 11.0761L12.3806 15.5L8.11389 11.0529L9.04722 10.0801L11.7139 12.8596L11.7139 1.35699L13.0472 1.35699L13.0472 12.8596L15.6917 10.1033L16.625 11.0761ZM9.13611 4.9239L8.20278 5.89669L5.55833 3.14044L5.55833 14.643L4.225 14.643L4.225 3.14044L1.55833 5.91985L0.625 4.94706L4.89167 0.500001L9.13611 4.9239Z"
        fill={fill}
      />
    </svg>
  );
};
